/**
 * Audit Trail Button — Small button to open audit trail modal.
 */

import { useState } from 'react'
import { GitBranch } from 'lucide-react'
import { Button } from '@/components/ui/button'
import AuditTrailModal from '@/components/AuditTrailModal'

interface AuditTrailButtonProps {
  emailId: string
  size?: 'sm' | 'default' | 'icon'
  variant?: 'ghost' | 'outline' | 'default'
  className?: string
  showLabel?: boolean
}

export default function AuditTrailButton({
  emailId,
  size = 'icon',
  variant = 'ghost',
  className = '',
  showLabel = false,
}: AuditTrailButtonProps) {
  const [showAuditTrail, setShowAuditTrail] = useState(false)

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setShowAuditTrail(true)
        }}
        title="Audit Trail"
      >
        <GitBranch className={size === 'icon' ? 'size-3.5' : 'size-4'} />
        {showLabel && <span className="ml-1.5">Audit</span>}
      </Button>
      <AuditTrailModal
        emailId={emailId}
        open={showAuditTrail}
        onOpenChange={setShowAuditTrail}
      />
    </>
  )
}